import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-connectors-create-dialog', {
    attrs: {
      "accounts": _vm.accounts,
      "isOpen": _vm.showCreateDialog
    },
    on: {
      "close": _vm.closeCreateDialog
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Connectors.Connectors.title'),
      "subtitle": _vm.$i18n_t('Connectors.Connectors.description')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "accounts-loaded": function ($event) {
              _vm.loadingAccounts = false;
            }
          }
        }), _vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "data-cy": "create-connector"
          },
          on: {
            "click": function ($event) {
              _vm.showCreateDialog = true;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.create')) + "\n      ")]) : _vm._e()];
      },
      proxy: true
    }])
  }), !_vm.isLoadingAccounts ? _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c('core-connectors-list', {
    ref: "bridges",
    attrs: {
      "accounts": _vm.accounts,
      "tenants": _vm.selectedAccounts
    },
    on: {
      "create": function ($event) {
        _vm.showCreateDialog = true;
      }
    }
  })], 1)], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };